export const API_BASE_URL = 'https://your-api-url.com/';
export const DEFAULT_API_PARAMS = ['limit', 'page', '$sort', 'sort'];
